import { AfterViewInit, Component, ElementRef, inject, OnInit, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonButtonRowWidget, CommonNumberFieldWidget, CommonSelectFieldWidget, CommonTextFieldWidget, UtilityService } from '@eforall/common';
import { DashboardDialogFramePart, DialogContext, DialogService } from '@eforall/dashboard';
import { AwardEditorDialogDataService } from './award-editor-dialog-data.service';
import { AwardEditorDialogForm, AwardFormFields } from './award-editor-dialog.form';

@Component({
	selector: 'award-editor-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		CommonSelectFieldWidget,
		CommonNumberFieldWidget,
		CommonTextFieldWidget,
		CommonButtonRowWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './award-editor.dialog.html',
})
export class AwardEditorDialog implements OnInit, AfterViewInit {

	public dialogContext: DialogContext<{ awardId?: number, eventId: number }> = inject(MAT_DIALOG_DATA);
	public dialogRef = inject(MatDialogRef<AwardEditorDialog>);

	public dialogDataService = inject(AwardEditorDialogDataService);
	public util = inject(UtilityService);
	public dialogService = inject(DialogService);

	public awardEditorForm = new AwardEditorDialogForm();
	public saveBtn = viewChild.required<ElementRef<HTMLButtonElement>>('formSaveBtn');

	async ngOnInit() {
		this.dialogDataService.resetDialogData();
		const awardId = this.dialogContext.data?.awardId;
		if (awardId) {
			await this.dialogDataService.getAwardDetails(awardId);
		} else {
			await this.dialogDataService.getAwardNamesAndDecidingRoles();
		}
	}

	ngAfterViewInit() {
		this.awardEditorForm.form.setSubmitButton(this.saveBtn(), async (values: AwardFormFields, changed: string[]) => {

			if (changed.length === 0) return;

			const dialogContextData = this.dialogContext.data;
			if (!dialogContextData) return;

			if (dialogContextData.awardId) {
				await this.dialogDataService.updateAward(dialogContextData.awardId, values.value, values.notes);
			} else {
				await this.dialogDataService.saveAwardDetails({ ...values, eventId: dialogContextData.eventId });
			}
			await this.dialogRef.close();
		});
	}

	resetForm() {
		this.awardEditorForm.form.resetAll();
	}

}
